import { useLocalStorageStore } from "@/store";

export const calculateDifferenceInDays = (currentDate: Date, storedDate: Date): number => {
	return (currentDate.getTime() - storedDate.getTime()) / (1000 * 3600 * 24);
};

export const evaluateAssessmentRetention = (assessmentExpiryDays: number, timestamp?: Date | null): boolean => {
	const functionalTestsUpdatedTimestamp = timestamp ?? useLocalStorageStore.getState().functionalTestsUpdatedTimestamp;

	if (functionalTestsUpdatedTimestamp === null || assessmentExpiryDays === 0) return false;

	const currentDate = new Date();
	const storedDate = new Date(functionalTestsUpdatedTimestamp);
	const differenceInDays = calculateDifferenceInDays(currentDate, storedDate);

	if (differenceInDays > assessmentExpiryDays) return false;

	return true;
};
